import type { PartSvgProps } from './types'

export default function RedDotSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 100,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 100 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main housing */}
      <rect x="12" y="22" width="76" height="36" rx="4"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Hood overhang (top front) */}
      <rect x="12" y="14" width="40" height="10" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
      {/* Lens window */}
      <rect x="16" y="26" width="24" height="28" rx="2"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Reticle dot */}
      <circle cx="28" cy="40" r="3" fill={accent} stroke="none" />
      {/* Battery cap (rear) */}
      <rect x="76" y="26" width="12" height="28" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1" />
      {/* Power button suggestion */}
      <circle cx="56" cy="58" r="4" fill="none" stroke={stroke} strokeWidth="1" />
      {/* Mount foot */}
      <rect x="18" y="58" width="64" height="10" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
    </svg>
  )
}
